'use strict';
var carswip = carswip || {};
const slides = document.getElementsByClassName('js-item-videoslide');
const thumbnails = document.getElementsByClassName('js-block-videoslider-thumbnail');
const videos = document.getElementsByClassName('js-block-video-slider video');
const blockVideos = document.getElementById('js-block-videoslider-videos');
const allPlayingItems = document.getElementsByClassName('item-videoslide--playing');

carswip.videoslider = carswip.videoslider || function () {

	function init() {
		if(slides && thumbnails) {
			for (let i = 0; i < slides.length; i++) {
				const currentVideo = slides[i];
				currentVideo.addEventListener('click', function(e) {
					const targetSlide = e.currentTarget;
					blockVideos.classList.toggle('block-videoslider-videos--playing');
					targetSlide.classList.toggle('item-videoslide--playing');
				});
			}


			for (let i = 0; i < thumbnails.length; i++) {
				var currentThumbnail = thumbnails[i];

				currentThumbnail.addEventListener('click', function(e){
					var activeSlide = document.querySelector('.item-videoslide--active');
					var activeThumb = document.querySelector('.block-videoslider-thumbnails__item--active');
					var clickedThumb = e.currentTarget;
					var theId = clickedThumb.getAttribute('data-id');
					var matchingSlide = document.querySelector('.js-item-videoslide[data-id="' + theId + '"]');

					var video = activeSlide.querySelector('.js-item-slide-video');
					video.pause();

					activeThumb.classList.remove('block-videoslider-thumbnails__item--active');
					clickedThumb.classList.add('block-videoslider-thumbnails__item--active');
					activeSlide.classList.remove('item-videoslide--active');
					matchingSlide.classList.add('item-videoslide--active');

					activeSlide.classList.remove('item-videoslide--playing');
					blockVideos.classList.remove('block-videoslider-videos--playing');
				});
			}
		}
	}

	return {
		init : init
	};

}();